// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2SnfC","largestCol":"styles_largestCol__1SErU","smallestCol":"styles_smallestCol__3nwWL"};